module.exports = __webpack_public_path__ + "img/file-type-zip.1d209569.svg";